import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ppl-box-container-with-title',
    templateUrl: './box-container-with-title.component.html',
    styleUrls: ['./box-container-with-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoxContainerWithTitleComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() small = false;
}
